// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__pfuzo","insightsList":"newBusinessInsightsMenu_insightsList__3tumb","active":"newBusinessInsightsMenu_active__MPXfo"};